var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"fields":_vm.fields,"url":_vm.url,"excelroute":true,"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }